// extracted by mini-css-extract-plugin
export default {"melodyVideo":"_M-z","isFullWidth":"aN-z","landingPageVideo":"bN-z","play":"cN-z","iframeVideo":"dN-z","playHidden":"eN-z","fullwidth":"fN-z"};